// MODULES
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// COMPONENTS
import Navbar from "../../components/app/Navbar";
import Modal from "../../components/app/Modal";
import CreditCardDetails from "../../components/profile/credit-card-details";
// IMAGES
import back from "../../assets/back.png";
import add from "../../assets/add.png";
import visaWhite from "../../assets/visa-white.png";
import mastercard from "../../assets/mastercard.png";
import edit from "../../assets/edit.png";
import cancel from "../../assets/cancel.png";
import EditCreditCardDetails from "../../components/profile/edit-credit-card";

export default function ConnectedCards() {
  const [addCardModal, setAddCardModal] = useState<boolean>(false);
  const [editCardModal, setEditCardModal] = useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="lg:grid grid-cols-3 gap-5 px-6 lg:px-16 py-6 lg:py-14 max-lg:space-y-7">
        <div>
          <div onClick={() => navigate(-1)}>
            <div className="flex items-center py-5 space-x-2 cursor-pointer">
              <img src={back} alt="" className="w-5" />
              <h1 className="font-medium text-lg">Back</h1>
            </div>
          </div>
        </div>
        <div className="col-span-2 border border-border rounded-lg p-5">
          <div>
            <div className="flex items-center justify-between">
              <h1 className="font-semibold text-2xl">Connect Cards</h1>
              <div
                onClick={() => setAddCardModal(!addCardModal)}
                className="flex items-center space-x-2 cursor-pointer"
              >
                <div>
                  <img src={add} alt="" className="w-4 h-4 md:w-5 md:h-5" />
                </div>
                <h1 className="text-base text-primary font-medium">
                  Add new card
                </h1>
              </div>
            </div>
            <div className="py-10 flex items-center justify-between w-full overflow-x-scroll">
              <div className="rounded-[10px] bg-primary p-5 md:w-[47%]">
                <div className="flex justify-between">
                  <div className="flex items-center space-x-4 py-3 text-white">
                    <div>
                      <h1 className="text-[16px] font-medium tracking-wide">
                        Kemi Shola
                      </h1>
                      <h2 className="font-medium">..... ..... ..... 24532</h2>
                    </div>
                  </div>
                  <div className="grid justify-items-end">
                    <img src={visaWhite} className="w-[30%]" alt="" />
                  </div>
                </div>
              </div>
              <div className="rounded-[10px] bg-accent p-5 md:w-[47%]">
                <div className="flex justify-between">
                  <div className="flex items-center space-x-4 py-3 text-themeText">
                    <div>
                      <h1 className="text-[16px] font-medium tracking-wide">
                        Shola Kemi
                      </h1>
                      <h2 className="font-medium">..... ..... ..... 24532</h2>
                    </div>
                  </div>
                  <div className="grid justify-items-end">
                    <img src={mastercard} className="w-[30%]" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-10 border rounded-[10px] border-border">
              <div className="border-b border-border p-4 flex items-center justify-between">
                <h1 className="font-semibold text-lg md:text-2xl">
                  Card Details
                </h1>
                <div className="flex items-center justify-end">
                  <div
                    onClick={() => setEditCardModal(!editCardModal)}
                    className="flex items-center justify-end space-x-1 cursor-pointer"
                  >
                    <img src={edit} alt="" className="w-[15%]" />
                    <h1 className="text-primary font-medium">Edit card</h1>
                  </div>
                  <div className="flex items-center space-x-1 justify-end cursor-pointer">
                    <img src={cancel} alt="" className="w-[11%]" />
                    <h1 className="text-error font-medium">Remove card</h1>
                  </div>
                </div>
              </div>
              <div>
                <div className="w-full p-4 lg:py-7 lg:px-10 space-y-7">
                  <div>
                    <h1 className="text-sm text-paragraph">Card name</h1>
                    <p className="text-lg font-medium">Kemi Shola</p>
                  </div>
                  <div>
                    <h1 className="text-sm text-paragraph">Card number</h1>
                    <p className="text-lg font-medium">.... .... .... 24532</p>
                  </div>
                  <div>
                    <h1 className="text-sm text-paragraph">Expiry date</h1>
                    <p className="text-lg font-medium">05/24</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* NEW CARD MODAL  */}
              <Modal
                header="Add credit or debit card"
                openModal={addCardModal}
                setOpenModal={() => setAddCardModal(!addCardModal)}
              >
                <div className="my-4">
                  <CreditCardDetails />
                </div>
              </Modal>

              {/* EDIT CARD MODAL  */}
              <Modal
                header="Add credit or debit card"
                openModal={editCardModal}
                setOpenModal={() => setEditCardModal(!editCardModal)}
              >
                <div className="my-4">
                  <EditCreditCardDetails
                    cardHolderName="Kemi Shola"
                    country="Nigeria"
                    cardNumber="**** **** **** 2532"
                    securityCode="535"
                    expiryDate="04/24"
                  />
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
